import { useEffect, useState } from "react"
import { Loader2 } from "lucide-react"
import { aiScoringStageLabel, formatElapsed } from "@/lib/gng-scoring-progress"

interface GoNoGoScoringProgressProps {
  /** Persisted stage from the assessment. Loosely typed — unknown values degrade. */
  stage: string | null
  /** Persisted ISO start time. The elapsed origin lives on the server so that
      leaving the tab and coming back still shows the true elapsed time. */
  startedAt: string | null
  criteriaCount: number
}

export function GoNoGoScoringProgress({ stage, startedAt, criteriaCount }: GoNoGoScoringProgressProps) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!startedAt) return
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [startedAt])

  const elapsed = formatElapsed(startedAt, now)

  return (
    <span className="inline-flex items-center gap-2 text-meta tabular-nums">
      <Loader2 className="h-3 w-3 animate-spin" />
      {/* Only the stage label is a live region: it changes 2–3 times a run and is worth
          announcing. The elapsed time ticks every second and deliberately sits outside,
          so screen readers aren't interrupted once a second for a non-actionable value. */}
      <span role="status">{aiScoringStageLabel(stage, criteriaCount)}</span>
      {elapsed && <span>· {elapsed}</span>}
    </span>
  )
}
